import React from 'react'
import { useDebug } from '../../hooks'
import MobileMenuProvider, { MobileMenuContext } from '../../contexts/MobileMenu';
import Hamburger from './Hamburger'
import { Components, Types } from '../../types';
import Sidebar from './Sidebar';
import _ from 'lodash';

/**
 * Main component to render its layout
 * @param props Components/MobileMenu
 * @returns React FC
 */
const MobileMenu: React.FC<Components.MobileMenu> = (props) => {
  useDebug('Components/MobileMenu') 
    
  const { config, theme: {dark: theme}, items: menuItems }: any = props  

  const items = React.useMemo(() => {

    const parsedItems = [];

    for ( const menuItem of menuItems ) {
      parsedItems.push(...menuItem.isCategoryMenu ? menuItem.items : [menuItem]);
    }

    return parsedItems;

  }, [menuItems]);

  return (
    <>
      {/* Context provider */}
      <MobileMenuProvider>
        {/* Menu opener */}
        {config.mobileMenu.showTrigger && <Hamburger config={config} theme={theme} /> }
        {/* Portal injecting the menu contents */}
        <Sidebar {...{...props, theme, items}} />
      </MobileMenuProvider>
    </>
  )
}

export default MobileMenu
